import { ApolloClient } from 'apollo-client'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { createUploadLink } from 'apollo-upload-client'
import { setContext } from 'apollo-link-context'

import { PATH_GRAPHQL, TOKEN_KEY } from '../config'
import Store from 'localforage'

const uploadToS3HttpLink = createUploadLink({
  uri: PATH_GRAPHQL
})

const authLink = setContext(async (_request, { headers }) => {
  const token = await Store.getItem(TOKEN_KEY)
  return {
    headers: {
      ...headers,
      'X-Auth-Token': token && token.token
    }
  }
})

const cache = new InMemoryCache({
  dataIdFromObject: object => {
    switch (object.__typename) {
      case 'Tee': return `${object.id}-${object.distance}-${object.color}-${object.name}`
      case 'CommentAuthor': return `${object.id}-${object.as && object.as.id}`
      default: return defaultDataIdFromObject(object)
    }
  }
})

export const uploadToS3ApolloClient = new ApolloClient({
  link: authLink.concat(uploadToS3HttpLink),
  cache
})

export const apolloClient = uploadToS3ApolloClient

export default apolloClient

